module.exports = __webpack_public_path__ + "static/media/ac3.87e36854.jpg";